import { httpGet, httpPost, httpPut } from '../http/actions'
import {
  GET_TOURNEES,
  GET_TOURNEES_SUCCESS,
  GET_TOURNEES_FAILURE,
  ADD_TOURNEE,
  ADD_TOURNEE_FAILURE,
  ADD_TOURNEE_SUCCESS,
  UPDATE_TOURNEE,
  UPDATE_TOURNEE_SUCCESS,
  UPDATE_TOURNEE_FAILURE,
} from './constants'

import { axiosHTTP } from '../../utils'
import { removeNull } from '../../utils/utils'
import queryString from 'query-string'

const polarisApi = process.env.REACT_APP_POLARIS_MS_URL

let CancelToken = axiosHTTP.CancelToken
let cancel
export default (store) => (next) => (action) => {
  // GET TOURNEES
  if (action.type === GET_TOURNEES) {
    // cancel the request
    if (cancel != undefined) {
      cancel()
    }

    const {
      tournees: { filter },
    } = store.getState()

    const { limit = 25, offset = 0, query } = filter
    const page = Math.floor(offset / limit) + 1
    const apiFilter = removeNull({
      limit,
      page,
      name: query,
    })

    store.dispatch(
      httpGet({
        endPoint: `${polarisApi}availabilities?${queryString.stringify(apiFilter)}`,
        cancelToken: new CancelToken(function executor(b) {
          // An executor function receives a cancel function as a parameter
          cancel = b
        }),
        success: GET_TOURNEES_SUCCESS,
        failure: GET_TOURNEES_FAILURE,
      })
    )
  }

  if (action.type === ADD_TOURNEE) {
    const { tournee } = action.payload
    store.dispatch(
      httpPost({
        endPoint: `${polarisApi}availabilities`,
        data: tournee,
        success: ADD_TOURNEE_SUCCESS,
        failure: ADD_TOURNEE_FAILURE,
      })
    )
  }

  if (action.type === UPDATE_TOURNEE) {
    const { newTournee, id } = action.payload

    store.dispatch(
      httpPut({
        endPoint: `${polarisApi}availabilities/${id}`,
        data: newTournee,
        success: UPDATE_TOURNEE_SUCCESS,
        failure: UPDATE_TOURNEE_FAILURE,
      })
    )
  }

  next(action)
}
